import React from "react";
import Profile from "../../Reuseable/Profile";
const AdminProfile = () => {
  return (
    <>
      <Profile />
    </>
  );
};

export default AdminProfile;
